import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { ShimmerContainer } from './ShimmerAnimation.styles';

interface ShimmerAnimationProps extends BoxProps {
  readonly enabled: boolean;
  /** Duration of one shimmer sweep in ms. @default 2500 */
  readonly durationMs?: number;
  readonly children: React.ReactNode;
}

/**
 * ShimmerAnimation - Adds a shimmer overlay effect to loading content
 *
 * Use this when you want to keep content visible with a shimmer effect.
 * For placeholder loading states, use the Skeleton component instead.
 */
export const ShimmerAnimation = React.memo<ShimmerAnimationProps>(({ enabled, durationMs = 2500, children, ...restProps }) => {
  return (
    <ShimmerContainer
      enabled={enabled}
      durationMs={durationMs}
      {...restProps}
    >
      {children}
    </ShimmerContainer>
  );
});

ShimmerAnimation.displayName = 'ShimmerAnimation';
